import { useEffect, useState } from "react";
import { IPoliticaRule, IPoliticas } from "../../../../Interfaces/base/IBase";
import { IPanelCambiarContrasenia } from "./PanelCambioContrasenia";
import usuarioServicio from "../../../../services/usuarioService";
import { IActualizarContrasenia } from "../../../../Interfaces/IUsuario";
import { CONTIENE_MAYUSCULA, CONTIENE_MINUSCULA, CONTIENE_NO_ALFANUMERICO, CONTIENE_NUMERO } from "../../../../utils/helpers/helpers";
import configuracionService from "../../../../services/configuracionService";
import { codigosRespuesta } from "../../../../Interfaces/base/IResponse";

export const UsePanelCambioContrasenia=(props:IPanelCambiarContrasenia)=>{
    const [politicas, setPoliticas] = useState<IPoliticaRule[]>([]);
    const [disableForm, setDisableForm] = useState(true);
    const [loading,setLoading]=useState<boolean>(false)
    const [status, setStatus] = useState<codigosRespuesta>(0);
    const [mensaje, setMensaje] = useState<string>("");
    const [form, setForm] = useState<IActualizarContrasenia>({
        usuarioId: props.usuarioId,
        password: "",
        confirmPassword: "",
    });
    const GetRequiereDigito=(value:string)=>{
        return CONTIENE_NUMERO.test(value)
    }
    const GetRequiereMayuscula=(value:string)=>{
        return CONTIENE_MAYUSCULA.test(value)
    }
    const GetRequiereMinuscula=(value:string)=>{
        return CONTIENE_MINUSCULA.test(value)
    }
    const GetRequiereAflanumerico=(value:string)=>{
        console.log("actual",value)
        return CONTIENE_NO_ALFANUMERICO.test(value)
    }
    const GetMayor=(actual:number,requerido:number)=>{
        console.log("actual",actual)
        console.log("requerido",requerido)
       return actual>=requerido
    }


    const dataApiPoliticas = () => {
        usuarioServicio
          .politicasContrasenia()
          .then((res) => {
            if (res.status == 200) {
                const politics:IPoliticaRule[]=[]
                const valor:IPoliticas=res.data
                if(valor.requiereDigito==true){
                    politicas.push({tipo:"requiereDigito",regla:GetRequiereDigito,numerador:false,
                    error:` - Se requiere al menos un dígito numérico`,state:false})
                }
                if(valor.requiereMayuscula==true){
                    politicas.push({tipo:"requiereMayuscula",regla:GetRequiereMayuscula,numerador:false,
                    error:`  - Se requiere al menos una letra mayúscula`,state:false})
                }
                if(valor.requiereMinuscula==true){
                    politicas.push({tipo:"requiereMinuscula",regla:GetRequiereMinuscula,numerador:false,
                    error:`  - Se requiere al menos una letra minúscula`,state:false})
                }
                if(valor.requiereNoAlfanumerico==true){
                    politicas.push({tipo:"requiereNoAlfanumerico",regla:GetRequiereAflanumerico,numerador:false,
                    error:` - Se requiere al menos un carácter no alfanumérico`,state:false})
                }
                if(valor.longitud>=0){
                    politicas.push({tipo:"longitud",reglaNumerador:GetMayor,numerador:true,valorNumerador:valor.longitud,error:
                `- Longitud mínima de ${valor?.longitud} caracteres`,state:false})
                }
              setPoliticas(politicas);
            }
          })
          .catch((e) => console.log(e));
    };
    useEffect(()=>{
        if(props.isOpen){
            dataApiPoliticas()
        }
    },[props.isOpen])
    useEffect(()=>{
      setDisableForm(!validarPoliticas())
    },[form])
    const validarPoliticas=()=>{
        if (!form.password) return false;
        const updatedPoliticas = politicas.map(politica => {
            if (politica.numerador && politica.reglaNumerador && politica.valorNumerador) {
                return {
                  ...politica,
                  state: politica.reglaNumerador(form.password.length, politica.valorNumerador)
                };
            }
            if (politica.regla) {
                return {
                  ...politica,
                  state: politica.regla(form.password)
                };
            }
        
            return politica;
        })
        setPoliticas(updatedPoliticas);
        return updatedPoliticas.every(politica => politica.state === true) && form.password==form.confirmPassword;
    }
    const reset=()=>{
        setMensaje("")
        setForm({
            usuarioId: props.usuarioId,
        password: "",
        confirmPassword: "",
        })
        setStatus(0)
        setPoliticas([])
        props.onDismiss()
    }
    const changePassword = () => {
        if (form) {
          let obj:IActualizarContrasenia = {
              usuarioId: form.usuarioId,
              confirmPassword: form.confirmPassword,
              password: form.confirmPassword
          };
          setDisableForm(true);
          setLoading(true)
          configuracionService
            .actualizarContraseniaUsario(obj)
            .then((res) => {
              if (res.status === 200) {
                 setMensaje("Se cambio contraseña correctamente")
                 setStatus(200)
                 setTimeout(()=>{
                    reset()
                 },3000)
              }
              setLoading(false)
            })
            .catch((e) => {
                setLoading(true)
                if (e.response.status === 500) {
                    setMensaje(e.response.data.detail);
                    setStatus(500)
                  }
                  if (e.response.status === 401) {
                    setMensaje("No cuenta con autorización");
                    setStatus(500)
                  }
            });
        }
    };
    const _onChangeText = (
        type: string,
        event: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>,
        newValue?: string
      ) => {
        if (event !== undefined) {
          if (newValue !== undefined) {
            switch (type) {
              case "password":
                setForm({
                  ...form,
                  password: newValue,
                });
                break;
              case "confirmPassword":
                setForm({
                  ...form,
                  confirmPassword: newValue,
                });    
                break;
              default:
                break;
            }
          }
        }
      };
      return {_onChangeText,changePassword,validarPoliticas,disableForm,politicas,status,loading,mensaje,form,reset}
    

}